import { useFormikContext } from 'formik';
import { Card } from '../../card/Card';
import { PipelineSettingsFeaturesData, SyncType } from '../interfaces/pipeline-settings-config';
import {
  PipelineSettingsFormFields,
  PipelineSettingsFormState
} from '../PipelineSettings/interfaces/pipeline-settings-form-state';
import { SyncFrequencyFormField } from './SyncFrequencyFormField/SyncFrequencyFormField';
import { SyncFrequencyWithCronFormField } from './SyncFrequencyWithCronFormField/SyncFrequencyWithCronFormField';
import { getSyncFrequencyWithCronFeatureOptions } from './SyncFrequencyWithCronFormField/utils';
import { SyncFrequencyWithSyncOnDemand } from './SyncFrequencyFormField/SyncFrequencyWithSyncOnDemand/SyncFrequencyWithSyncOnDemand';
import { Banner } from '../../banner/Banner';
import {
  SYNC_ON_DEMAND_WARNING_BANNER_DESCRIPTION,
  SYNC_ON_DEMAND_WARNING_BANNER_TITLE
} from './strings';

export function PipelineSettingsSyncFrequency({
  disabled,
  featureOptions
}: {
  disabled: boolean;
  featureOptions: PipelineSettingsFeaturesData;
}) {
  const formikProps = useFormikContext<PipelineSettingsFormState>();

  const showLegacyScheduler = !featureOptions.features.sync_frequency_type;

  const showSchedulerWithCron = !!featureOptions.features.sync_frequency_type;

  const showSchedulerWithSyncOnDemand = !!featureOptions.features.sync_type;

  const syncOnDemandSelected =
    formikProps.values[PipelineSettingsFormFields.SYNC_TYPE] === SyncType.ON_DEMAND;

  return (
    <Card
      gridColumns={1}
      className='mt-5'
      title='Sync Frequency'
      subtitle='Specify the frequency at which your Pipeline should run'
      dataId='sync-frequency'
    >
      {showSchedulerWithSyncOnDemand ? (
        <SyncFrequencyWithSyncOnDemand
          currentValue={formikProps.values[PipelineSettingsFormFields.SYNC_TYPE]}
          defaultValue={formikProps.values[PipelineSettingsFormFields.SYNC_TYPE]}
          featureOptions={featureOptions.features.sync_type!}
          onChange={async syncType => {
            await formikProps.setFieldValue(PipelineSettingsFormFields.SYNC_TYPE, syncType);
          }}
        />
      ) : null}

      {showLegacyScheduler ? (
        <SyncFrequencyFormField
          featureOptions={featureOptions.features.sync_frequency_in_ms!}
          fieldName={PipelineSettingsFormFields.SYNC_FREQUENCY}
          disabled={disabled}
        />
      ) : null}

      {showSchedulerWithCron && !syncOnDemandSelected ? (
        <SyncFrequencyWithCronFormField
          featureOptions={getSyncFrequencyWithCronFeatureOptions(featureOptions)}
          fieldName={PipelineSettingsFormFields.SYNC_FREQUENCY}
          disabled={disabled}
        />
      ) : null}

      {syncOnDemandSelected ? (
        <div>
          <Banner
            open
            dataId='sync-on-demand-warning-banner'
            color='warning'
            icon='warning'
            className='text-default mt-5'
          >
            <div className='flex flex-col gap-1'>
              <span className='text-bold'>{SYNC_ON_DEMAND_WARNING_BANNER_TITLE}</span>
              <span>{SYNC_ON_DEMAND_WARNING_BANNER_DESCRIPTION}</span>
            </div>
          </Banner>
        </div>
      ) : null}
    </Card>
  );
}
